import CreateOnboardingLinkModal from './CreateOnboardingLinkModal';

export default {
  CreateOnboardingLinkModal,
};
